
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShiftPaygradeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShiftPaygrade"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"paygradeType"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"payType"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"paygradeForType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"paygradeForId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shiftId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":158}};
    doc.loc.source = {"body":"fragment ShiftPaygradeFragment on ShiftPaygrade {\n  id\n  paygradeType {\n    id\n    name\n    payType\n  }\n  paygradeForType\n  paygradeForId\n  shiftId\n  value\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
